import React, { FC } from 'react'

import styles from '../Story.module.scss'
import { cn } from '../../../shared/utils'

type TStoryBodyProps = {}

export const StoryBody: FC<TStoryBodyProps> = (props) => {
  return (
    <div className={cn(styles.body, styles.section)}>
      {props.children}
    </div>
  )
}
